module.exports = __webpack_public_path__ + "img/w3_trash_white.f82e28dd.f82e28dd.png";